import { getColorFromId } from "@nova/util-strings"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import * as Icons from "@nova/component-icons"
import { selectLiveVideoFlights } from "features/entity-caching/flights/selectors"
import { LiveVideoFlight } from "@nova/protobuf"
import { useRef } from "react"
import { Tooltip } from "panels/content/top-bar/TODO-put-in-package/Tooltip"
import { useFullnameForUserId } from "features/data-management/users/storage"
import { dateFromNumber } from "@nova/serializer/src/client/util"
import { openVideoFlight } from "plugins/Video/state/thunks"
import { ProfilePhoto } from "features/data-management/workspace/workspace/body/settings-and-collaborators/profile/ProfilePhoto"

const Drone = ({ drone }: { drone: LiveVideoFlight }) => {
    const dispatch = useAppDispatch()
    const ref = useRef<HTMLDivElement>(null)
    const { fullName } = useFullnameForUserId(drone.createdBy!.userId)
    return (
        <>
            <div
                className="rounded-lg flex justify-center items-center text-gray-0 pl-px w-[32px] relative group/tooltip"
                style={{ backgroundColor: getColorFromId(drone.id) }}
                ref={ref}
            >
                <svg
                    className="absolute top-[3px] right-[3px]"
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="3" cy="3" r="3" fill="#FF5D55" fillOpacity="0.75" />
                    <circle cx="3" cy="3" r="2" fill="#FF3B30" />
                </svg>
                <button
                    className="w-full h-full disabled:cursor-not-allowed"
                    onClick={() => dispatch(openVideoFlight({ flightId: drone.id }))}
                >
                    <Icons.LiveDrone className="m-auto" />
                </button>
                <Tooltip>
                    <div className="flex flex-col">
                        <small className="text-center text-gray-50">{drone.name}</small>
                        {fullName && (
                            <div className="flex items-center gap-1">
                                <div className="w-4 min-w-[16px] aspect-square rounded-sm overflow-hidden">
                                    <ProfilePhoto
                                        userId={drone.createdBy!.userId}
                                        fullName={fullName}
                                    />
                                </div>
                                <small className="text-white">{fullName}</small>
                                {drone.startedAt && (
                                    <small className="text-gray-400">
                                        {dateFromNumber(drone.startedAt).getHours()}:
                                        {dateFromNumber(drone.startedAt).getMinutes()}
                                    </small>
                                )}
                            </div>
                        )}
                    </div>
                </Tooltip>
            </div>
        </>
    )
}

export const DronesPreview = () => {
    const drones = useAppSelector(selectLiveVideoFlights)

    return (
        <div className="mr-1 flex gap-1">
            {drones
                .filter((e) => e.live && !e.endedAt && e.startedAt)
                .map((drone, idx) => (
                    <Drone drone={drone} key={idx} />
                ))}
        </div>
    )
}
